import { BaseEntity } from ".";
import { IGet_corporations_corporation_id_customs_offices_200_ok } from "../service/esiclient";
import { getCachedCorporationEntity } from "./CorporationEntityCache";

export class CorporationCustomsOfficeEntity extends BaseEntity {
  private _corporation_id: number;
  constructor(id: number, props: any, corporation_id: number, character_id: number) {
    super(id, props);
    this._corporation_id = corporation_id;
    this._character_id = character_id;
    this._dataTypeName = "Corporation Customs Office";
  }

  async toJson(): Promise<Excel.EntityCellValue> {
    //This dataset is very basic
    const props: Partial<IGet_corporations_corporation_id_customs_offices_200_ok> = this.props;
    var entity = await super.toJson();
    // Properties
    if (entity.properties) {
      delete entity.properties["office_id"];
      const corpEntity = await getCachedCorporationEntity(this._corporation_id);
      if (corpEntity !== null) {
        entity.properties["owner"] = await corpEntity.toJson();
      }
      entity.text = "Customs office in " + props.system_id?.toString();
      entity.properties["name"] = {
        type: Excel.CellValueType.string,
        basicValue: entity.text,
      };
    }
    // Layouts
    entity.layouts = {
      card: {
        title: { property: "name" },
      },
    };

    return entity;
  }
}
